// Theme Store - Light/Dark/Auto Mode with Settings
import { signal, computed, effect } from '@preact/signals'
import { safeLocal } from '../utils/safeStorage.js'

// Theme state - Always dark mode
export const themeMode = signal('dark') // Always 'dark'
export const isSettingsOpen = signal(false)

// Actual applied theme (always dark)
export const appliedTheme = computed(() => 'dark')

// Actions
export function setThemeMode(mode) {
  // Always dark mode, ignore input
  themeMode.value = 'dark'
  safeLocal.set('theme-mode', 'dark')
  applyTheme()
}

export function toggleSettings() {
  isSettingsOpen.value = !isSettingsOpen.value
}

export function closeSettings() {
  isSettingsOpen.value = false
}

// Apply theme to DOM (always dark)
function applyTheme() {
  if (typeof document === 'undefined') return
  
  document.documentElement.setAttribute('data-theme', 'dark')
  
  // Update meta theme-color for mobile browsers
  const metaTheme = document.querySelector('meta[name="theme-color"]')
  if (metaTheme) {
    metaTheme.setAttribute('content', '#1a1a1a')
  }
}

// Effect: Apply theme on change
effect(() => {
  applyTheme()
})

// Initialize theme on load
applyTheme()
